import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import IBIcon from '@swf/core/assets/casino/instant-bonus-icon-fill.svg';
import FSBIcon from '@swf/core/assets/icons/free-spins.svg';
import StarsCoinIcon from '@swf/core/assets/icons/stars-coin.svg';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { RewardType, StarsCoinReward } from '@swf/core/types/StarsCoinReward';
import { isFSBType } from '@swf/core/utils/casino';

import InsufficientIcon from '../../assets/padlock.svg';
import Action from '../Action/Action';

import styles from './RewardStoreTile.scss';

interface Props {
  reward: StarsCoinReward;
  showCollect: boolean;
}

const Icon = ({ rewardType }: { rewardType: RewardType }) =>
  isFSBType(rewardType) ? <FSBIcon /> : <IBIcon />;

const RewardStoreTile: React.FC<Props> = ({ reward, showCollect }) => {
  const { name, price } = reward;
  const balance = useSelector(select.account.getStarsCoinBalance);
  const { modal } = useDispatch<Dispatch>();
  const isMobile = useSelector(select.device.isMobile);
  const { greaterThan } = useScreenSize();
  const useButton = !isMobile && greaterThan(Size.Medium);
  const affordable = balance >= price;

  const handleClick = () =>
    affordable &&
    modal.enqueue({
      path: '/casino/buy-reward',
      locationState: { reward }
    });

  return (
    <li
      className={classNames(
        styles.container,
        {
          [styles.notAffordable]: !affordable,
          [styles.mobile]: !useButton
        },
        isFSBType(reward.type) ? styles.fsb : styles.ib
      )}
      onClick={handleClick}
    >
      <div className={classNames(styles.icon, isFSBType(reward.type) ? styles.fsb : styles.ib)}>
        {!affordable && <InsufficientIcon className={styles.insufficient} />}
        <Icon rewardType={reward.type} />
      </div>
      <div className={styles.info}>
        <div className={styles.name}>
          <p>{name}</p>
        </div>
        <div className={styles.price}>
          <StarsCoinIcon className={styles.priceIcon} />
          <p className={styles.priceText}>{price}</p>
        </div>
        {useButton && <Action balance={balance} price={price} showCollect={showCollect} />}
      </div>
    </li>
  );
};

export default RewardStoreTile;
